import { CircularProgress } from "@mui/material";
import * as React from "react";
const InlineSpinner = ({ loading }) => {
  return (
    <div>
      {/* <Backdrop sx={{ 
        color: "#fff",
         zIndex: (theme) => theme.zIndex.drawer + 1 
         }} open={loading}> */}
        <CircularProgress color="inherit" size={16} sx={{ pb: 0 }}/>
      {/* </Backdrop> */}
    </div>
  );
};

export default InlineSpinner;
